import React, { useContext } from 'react';
import { SchoolContext } from '../../context/SchoolContext';
import TeacherList from './TeacherList';
import AddTeacher from './AddTeacher';
import Card from '../ui/Card';

const TeacherManagement = () => {
    const { teachers, setTeachers } = useContext(SchoolContext);

    return (
        <Card title="Teacher Management">
            <AddTeacher setTeachers={setTeachers} />
            <TeacherList teachers={teachers} />
        </Card>
    );
};

export default TeacherManagement;
